import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-tosite-luku',
  templateUrl: './tosite-luku.component.html',
  styleUrls: ['./tosite-luku.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TositeLukuComponent {
  alivalilehtiIndex = 0
}
